import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/globals.css";

// After a new deploy, old JS chunk files no longer exist on the server.
// A tab/task pane left open from before the deploy will fail to load
// them on the next lazy import — reload once to pick up the current build.
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

function renderApp(isExcelHost: boolean) {
  const root = document.getElementById("root");
  if (root) {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <App isExcelHost={isExcelHost} />
      </React.StrictMode>
    );
  }
}

// Office.onReady fires when inside Excel and reports which host loaded us.
// In a regular browser, Office.js loads but onReady may not fire
// or Office may not exist. We use a fallback timeout, treating that
// case as "not Excel".
if (typeof Office !== "undefined") {
  let rendered = false;
  Office.onReady((info) => {
    rendered = true;
    renderApp(info.host === Office.HostType.Excel);
  });
  // Fallback: if Office.onReady doesn't fire in 3s (browser), render anyway
  setTimeout(() => {
    if (!rendered) renderApp(false);
  }, 3000);
} else {
  renderApp(false);
}
